export default __webpack_public_path__ + "static/pupsicle-e5d63ffff5795bd106131cb3fa5b8588.png";